import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { Modal } from '../components';
import { login, loginLocationUser } from "../services";
import wastewijzer_logo from "../assets/wastewijzer_logo.png";
import logo from "../assets/logo.png";

const Login = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [refresh, setRefresh] = useState();

  const handleClick = (customer = false) => {
    sendLogin(customer);
  };

  async function sendLogin(customer) {
    let res = null;
    if (customer) res = await loginLocationUser(email, password);
    else res = await login(email, password);
    if(res.token) {
      props.updateToken();
      setRefresh(true);
      console.log(200)
      return res;
    }
    if(res.status == 401) {
      console.log(401)
      setShowModal(true);
      document.querySelector('.overlay').classList.toggle('modal__active');
    }
    else {
      console.log('else')
      console.log(res)
    }
  }

  return (
    <div className="login">
      <div className="login__form">
        {showModal && 
          <Modal header="Inloggen mislukt">
            <p>Gebruikersnaam of wachtwoord onjuist</p>
          </Modal>
        }
        <img src={logo} className="login__form__logo" alt="Care Culinair" />
        <label className="login__form__label" htmlFor="">
          Email
        </label>
        <input
          onChange={(e) => setEmail(e.target.value)}
          type="text"
          className="login__form__input"
        />
        <label className="login__form__label" htmlFor="">
          Wachtwoord
        </label>
        <input
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          className="login__form__input"
        />
        <button onClick={() => handleClick(false)} className="login__form__button">
          Inloggen
        </button>
        <button onClick={() => handleClick(true)} className="login__form__button">
          Inloggen als klant
        </button>
        {refresh && <Redirect to="/" />}
      </div>
      <div className="login__background">
        <img src={wastewijzer_logo} alt=""/>
      </div>
    </div>
  );
};

export default Login;
